import React from 'react'
import PropTypes from 'prop-types'

const DEFAULT_COLOR = 'currentColor'
const DEFAULT_WIDTH = 24
const DEFAULT_HEIGHT = 19

const ServiceLearningProjectIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      version="1.1"
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ss_servicelearningprojects</title>
      <defs>
        <polygon
          id="path-1"
          points="0 0 9.98214793 0 9.98214793 9.55561664 0 9.55561664"
        />
      </defs>
      <g
        fill="none"
        fillRule="evenodd"
        id="ss_servicelearningprojects"
        stroke="none"
        strokeWidth="1"
      >
        <g
          id="service-learning-projects-icon"
          transform="translate(1.000000, 0.000000)"
        >
          <path
            d="M21.8252849,12.755732 C21.4120361,11.8220378 20.3924731,11.3825005 19.4834067,11.7454844 L15.6621706,13.3492364 C15.6690513,13.2344062 15.6597421,13.1191459 15.6346476,13.0068962 C15.4083929,12.0981464 14.7138435,11.9725643 13.6598768,11.782901 L13.1567737,11.6891445 C12.7216685,11.6035594 12.3165146,11.5450691 11.7053435,11.4564736 C11.2775237,11.3949727 10.741636,11.3175591 10.0118734,11.2053094 C8.21073993,10.9378023 6.72652503,11.1893966 4.33202945,12.2052352 C3.19508927,12.6998222 1.77118199,12.7987396 0.427819782,12.846478 C0.191446317,12.846478 0,13.0499037 0,13.3010679 L0,13.3144002 C0.00566648718,13.5694351 0.202779291,13.7715706 0.442795498,13.7685601 C1.87925,13.7152307 3.38127385,13.5952396 4.64409099,13.0576451 C6.90825737,12.0955659 8.23097738,11.8577341 9.88397264,12.1114787 C10.6161637,12.2237285 11.141528,12.3041526 11.5843235,12.3789858 C12.1833522,12.4645708 12.5909345,12.5230611 13.0005406,12.6034852 C13.1867252,12.6409018 13.357934,12.670147 13.5165957,12.6998222 C14.585538,12.892066 14.7316524,12.9668991 14.8069358,13.2610709 C14.82434,13.330313 14.8069358,13.4696575 14.6057755,13.7341541 C14.2912854,14.1508973 13.6647338,14.3061546 13.1741779,14.3087351 L9.73542973,13.8919918 C9.50027051,13.8709181 9.29344373,14.0567108 9.27361102,14.3065847 C9.25458781,14.5487173 9.41851119,14.7637551 9.64476593,14.7951506 L13.1065849,15.1908202 L13.151512,15.1908202 C13.7800873,15.2045826 14.3965202,15.0063178 14.9125753,14.6239805 L19.7978967,12.5927334 C20.2840004,12.3991993 20.8287926,12.6310101 21.0558569,13.1273174 C21.1712104,13.3849327 21.1817338,13.6812548 21.0858083,13.9479016 C20.9971683,14.2253004 20.8041029,14.45066 20.552349,14.5706511 L14.688749,17.4229127 C14.6737733,17.4229127 12.9758509,18.1630728 11.5717763,18.0912502 C10.8472755,18.0456622 9.98718366,17.7329972 9.1291156,17.4203322 C8.27145229,17.1072372 7.47126335,16.8079045 6.75202423,16.7679075 C5.61751254,16.7012458 2.80248266,17.2676554 1.93429587,17.4332345 C1.70075565,17.4805428 1.5477605,17.7196649 1.5922829,17.9678185 C1.63478155,18.2133917 1.85658405,18.3755302 2.08729103,18.3303723 C2.09012427,18.3299422 2.09255277,18.329082 2.09538601,18.328652 C4.63599601,17.8207326 5.96235876,17.6310693 6.71681106,17.6740769 C7.31057796,17.708913 8.06260176,17.9867418 8.85995746,18.2809136 C9.76052417,18.6125019 10.6914471,18.954412 11.5418249,19 L11.7931741,19 C13.3304111,19 14.9680259,18.289085 15.0635467,18.2512383 L20.8947667,15.3912354 C21.8313561,14.9516981 22.2551284,13.7883436 21.8414748,12.7931486 C21.8362131,12.7806764 21.8309514,12.7682042 21.8252849,12.755732 Z"
            fill={color}
            id="Stroke-3"
            stroke={color}
            strokeWidth="0.55"
          />
          <g id="Group-7" transform="translate(9.239373, 0.000000)">
            <mask fill="white" id="mask-2">
              <use xlinkHref="#path-1" />
            </mask>
            <g id="Clip-6" />
            <path
              d="M2.68331257,-0.00021145257 C1.98950769,-0.00021145257 1.2997272,0.290747281 0.77977598,0.872241842 C-0.260528898,2.03480806 -0.259321581,3.88840127 0.77977598,5.0518133 L4.66492232,9.40942782 C4.83153208,9.59592898 5.11001988,9.60523289 5.28749549,9.43015017 C5.29433696,9.42338369 5.30077598,9.4166172 5.30761744,9.40942782 C6.60508086,7.9588632 7.90415403,6.50702987 9.20161744,5.05646526 C10.2423248,3.89389904 10.2423248,2.03988292 9.20161744,0.877316704 C8.16131257,-0.285672419 6.43042232,-0.285672419 5.39011744,0.877316704 L4.99049549,1.32094419 L4.59167842,0.872241842 C4.07132476,0.290747281 3.37711744,-0.00021145257 2.68331257,-0.00021145257"
              fill={color}
              id="Fill-5"
              mask="url(#mask-2)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

ServiceLearningProjectIcon.defaultProps = {
  color: DEFAULT_COLOR,
  height: DEFAULT_HEIGHT,
  width: DEFAULT_WIDTH,
}

ServiceLearningProjectIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
}

export default ServiceLearningProjectIcon
